var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDianxian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:wire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 3.18334V9.56668C1.5 10.5948 1.90843 11.5809 2.63545 12.3079C3.36247 13.0349 4.34851 13.4433 5.37667 13.4433C6.40482 13.4433 7.39087 13.0349 8.11788 12.3079C8.8449 11.5809 9.25333 10.5948 9.25333 9.56668V3.80668C9.25245 3.47454 9.12012 3.15626 8.88527 2.92141C8.65041 2.68655 8.33213 2.55422 8 2.55334",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4999 3.18334V9.56668C14.4999 10.0758 14.3996 10.5799 14.2048 11.0502C14.01 11.5206 13.7244 11.9479 13.3645 12.3079C13.0045 12.6679 12.5771 12.9534 12.1068 13.1483C11.6364 13.3431 11.1323 13.4433 10.6232 13.4433C9.59509 13.4433 8.60905 13.0349 7.88203 12.3079C7.15502 11.5809 6.74658 10.5948 6.74658 9.56668V3.80668C6.74746 3.47454 6.87979 3.15626 7.11465 2.92141C7.3495 2.68655 7.66778 2.55422 7.99992 2.55334",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianxian);
export default __webpack_public_path__ + "static/media/dianxian.0cb882bb34b03683bb341350af6d596f.svg";
export { ForwardRef as ReactComponent };